module.exports = __webpack_public_path__ + "media/images/talent/lp/step03-a1d8e252cfe0fddab7d1525583656c52.png";